import React, { useState } from 'react';
import CloseIcon from '../../../../assets/icons/close.svg';
import { AuthenticatedDELETERequest } from '../../../../utils';

const DeletePermissionsModal = (props) => {
    const { id, label, description, btnText, screen, open, onError, onClose } = props;
    const [loading, setLoading] = useState(false);
    const onDelete = async (endpoint, iD) => {
        setLoading(true);
        try {
            const { success, message } = await AuthenticatedDELETERequest(`${endpoint}/${iD}`);
            if (!success) {
                onError(`Failed: endpoint=${endpoint} with id:=${iD} Error: ${message}`);
                setLoading(false);
                onClose();
            }else{
                setLoading(false);
                onClose();
                window.location.reload();
            }
        } catch (error) {
            setLoading(false);
            onError('براہ کرم دوبارہ کوشش کریں۔');
            onClose();
        }
    };

    return open ? (
        <div
            className='flex column justifyCenter alignCenter'
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1000,
                background: 'rgba(0,0,0,0.7)',
            }}
        >
            <div
                style={{
                    background: '#ffffff',
                    height: 320,
                    maxHeight: 320,
                    width: 576,
                    borderRadius: 8,
                }}
            >
                <div className='h-100 w-100' style={{ overflow: 'auto' }}>
                    <div
                        className='flex justifyBetween alignCenter w-100'
                        style={{
                            borderBottom: '1px solid #E0E0E0',
                            padding: '20px 16px 8px',
                            height: 72,
                        }}
                    >
                        <h2 className='flex alignCenter w-100' style={{ color: '#009688' }}>
                            {label}
                        </h2>
                        <img
                            src={CloseIcon}
                            alt='close_icon'
                            height={32}
                            width={32}
                            onClick={onClose}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>

                    <div
                        className='flex column justifyCenter alignCenter urdu'
                        style={{ padding: 20, height: 'calc(100% - 156px)' }}
                    >
                        <h1 className='flex alignCenter w-100' style={{ color: '#ff0000' }}>
                            {description}
                        </h1>
                    </div>

                    <div
                        className='flex justifyEnd alignCenter w-100'
                        style={{ height: 64, paddingLeft: 16 }}
                    >
                        <div className='flex justifyBetween alignCenter'>
                            <div
                                className='flex justifyEnd alignCenter register_button'
                                style={{ margin: '0 8px' }}
                                onClick={() => onDelete(screen, id)}
                            >
                                {loading ? <div className='custom_loader' /> : <h3>{btnText}</h3>}
                            </div>
                            <div
                                className='flex justifyEnd alignCenter delete_button'
                                style={{ margin: '0 8px' }}
                                onClick={onClose}
                            >
                                <h3>{`منسوخ کریں`}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ) : null;
};

export default DeletePermissionsModal;
